'use client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function ScrollToHash() {
    const pathname = usePathname();

    useEffect(() => {
        const hash = window.location.hash;
        if (!hash) return;

        const id = hash.slice(1);
        let attempts = 0;

        const tryScroll = () => {
            const el = document.getElementById(id);
            if (el) {
                const headerOffset = 80;
                const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
                window.scrollTo({ top, behavior: 'smooth' });
                return;
            }
            if (++attempts < 15) setTimeout(tryScroll, 100);
        };

        // Delay start to let ConditionalLayout's scroll-reset timers (0ms, RAF, 100ms) finish
        setTimeout(tryScroll, 150);
    }, [pathname]);

    return null;
}
